const footerSubLink = [
    {
        title : 'Terms of Service',
        link : 'https://www.arvancloud.ir/en/legal/terms'
    },
    {
        title : 'Service Level Agreement',
        link : 'https://www.arvancloud.ir/en/legal/sla'
    },
    {
        title : 'Privacy Policy',
        link : 'https://www.arvancloud.ir/en/legal/privacy-policy'
    },
]

export default footerSubLink